<template>
  <f7-page class="page-bot-forwarder-create" @page:init="pageMounted" @page:reinit="pageMounted">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>TẠO BOT HỘI VIÊN</f7-nav-title>
    </f7-navbar>
    <template>
      <f7-list inset inline-labels>
        <f7-list-item title="Khách hàng" smart-select :smart-select-params="{openIn: 'popup', closeOnSelect: true}">
          <select name="customer" @change="changeCustomer($event.target.value)">
            <option value="">- Chọn -</option>
            <optgroup label="Khách">
              <option v-for="(cust, idx) in _.filter(customers, {type: 1})" :key="idx" :value="cust.id" :selected="form_bot.customer_id === cust.id">
                {{ cust.fullname }}
              </option>
            </optgroup>
            <optgroup label="Chủ">
              <option v-for="(cust, idx) in _.filter(customers, {type: 2})" :key="idx" :value="cust.id" :selected="form_bot.customer_id === cust.id">
                {{ cust.fullname }}
              </option>
            </optgroup>
          </select>
          <f7-icon slot="media" ios="f7:person" color="crimson"></f7-icon>
        </f7-list-item>
        <f7-list-input label="Nền tảng" type="select" @input="form_bot.bot_type = $event.target.value">
          <f7-icon slot="media" ios="f7:ant" color="crimson"></f7-icon>
          <option value="telegram_forwarder">Telegram</option>
        </f7-list-input>
        <f7-list-input label="Mã phòng" type="text" :value="form_bot.source_room_code" @input="form_bot.source_room_code = $event.target.value">
          <f7-icon slot="media" ios="f7:ant" color="crimson"></f7-icon>
        </f7-list-input>
      </f7-list>
      <f7-block inset class="mt-1">
        <f7-button fill color="primary" @click.prevent="submitForm">XÁC NHẬN</f7-button>
      </f7-block>
      <f7-block strong inset class="alert-warning margin-bottom box-shadow mt-2" v-if="user_info.server_region === 'hanoi'">
        <p>Bước 1: Chọn khách hàng bạn muốn liên kết với nhóm bot.</p>
        <p>Bước 2:</p>
        <ul>
          <li>Trên ứng dụng telegram bạn đã có sẵn phòng chat bot auto. Bấm <b>/thongtin</b></li>
          <li>Bot sẽ gởi cho bạn thông tin phòng chat kèm <b class="text-color-red">mã liên kết phòng</b>. Bấm chọn copy</li>
        </ul>
        <p>Bước 3 : Vào lại app KIỐT SỐ nhập vào " Mã phòng " và xác nhận.</p>
      </f7-block>
      <f7-block strong inset class="alert-warning margin-bottom box-shadow mt-2" v-else>
        <p>Bước 1: Chọn khách hàng bạn muốn liên kết với nhóm bot.</p>
        <p>Bước 2:</p>
        <ul>
          <li>Trên ứng dụng telegram bạn đã có sẵn phòng chat bot auto. Bấm <b>/thongtin</b></li>
          <li>Bot sẽ gởi cho bạn thông tin phòng chat kèm <b class="text-color-red">mã liên kết phòng</b>. Bấm chọn copy</li>
        </ul>
        <p>Bước 3 : Vào lại app KIỐT SỐ nhập vào " Mã phòng " và xác nhận.</p>
      </f7-block>
    </template>
  </f7-page>
</template>
<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['customers', 'user_info']),
  },
  data() {
    return {
      form_bot: {
        customer_id: '',
        bot_type: 'telegram_forwarder',
        source_room_code: ''
      },
      result: {}
    }
  },
  methods: {
    changeCustomer(cust_id) {
      this.form_bot.customer_id = cust_id;
    },
    submitForm() {
      let self = this;
      self.$f7.dialog.preloader();

      self.$store.dispatch('generateBotChatRoom', self.form_bot).then((res) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Tạo bot thành công', 'THÔNG BÁO!', function() {
          self.$f7.views.main.router.back();
        });
      }).catch((err) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    pageMounted() {

    }
  },
};
</script>
